import DOMPurify from 'dompurify';

export const SafeHtml = ({ html, className = '', testId }) => {
  if (!html) return null;
  return (
    <div
      data-testid={testId}
      className={`jf-prose ${className}`}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html, { ADD_ATTR: ['target'] }) }}
    />
  );
};
